// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"89f0ec5b","918":"de9b1a8e"}[chunkId] + ".chunk.js";
};